import { onBeforeUnmount, onMounted, unref } from 'vue'

// Holds a reload or a closed tab behind the browser's own "leave site?" prompt
// while `dirty` is true. The in-app leave guard (onBeforeRouteLeave) only sees
// router navigation, so without this a page of unsaved edits goes without a
// word the moment the merchant reloads.
export function useUnloadGuard(dirty) {
  const holdUnload = event => {
    if (!unref(dirty)) return
    event.preventDefault()
    event.returnValue = ''
  }
  onMounted(() => window.addEventListener('beforeunload', holdUnload))
  onBeforeUnmount(() => window.removeEventListener('beforeunload', holdUnload))
  return holdUnload
}
